import { render, staticRenderFns } from "./predictionData.vue?vue&type=template&id=1dfaeea2&scoped=true&"
import script from "./predictionData.vue?vue&type=script&lang=js&"
export * from "./predictionData.vue?vue&type=script&lang=js&"
import style0 from "./predictionData.vue?vue&type=style&index=0&id=1dfaeea2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfaeea2",
  null
  
)

export default component.exports